import { createColumnHelper } from '@tanstack/react-table'
import type { Environment } from '../../../../../../types'
import { formatNumber } from '../../../utils/formatNumber'

export default function environmentReportTableColumns() {
  const columnHelper = createColumnHelper<Environment>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      enableSorting: false,
      header: 'Reg.nr.',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('vehicleID', {
      id: 'vehicleID',
      enableSorting: false,
      header: 'Kjøretøy-ID',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('invoiceGroup', {
      id: 'invoiceGroup',
      header: 'Fakturagruppe',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('carDescription', {
      id: 'carDescription',
      enableSorting: false,
      header: 'Objekt',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('totalKm', {
      id: 'totalKm',
      sortingFn: 'alphanumeric',
      meta: {
        alignmentType: 'right',
      },
      header: 'Kilometer',
      cell: (row) => formatNumber(row.getValue()),
    }),
    columnHelper.accessor('volume', {
      id: 'volume',
      sortingFn: 'alphanumeric',
      meta: {
        alignmentType: 'right',
      },
      header: 'Liter',
      cell: (row) => formatNumber(row.getValue()),
    }),
    columnHelper.accessor('fuelType', {
      id: 'fuelType',
      enableSorting: false,
      header: 'Drivstoff',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('fuelConsumptionL10KM', {
      id: 'fuelConsumptionL10KM',
      sortingFn: 'alphanumeric',
      meta: {
        alignmentType: 'right',
      },
      header: 'L/mil',
      cell: (row) => formatNumber(row.getValue()),
    }),
    columnHelper.accessor('co2Emission', {
      id: 'co2Emission',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Sum CO2',
        alignmentType: 'right',
      },
      header: 'CO2',
      cell: (row) => `${formatNumber(row.getValue(), { digits: { min: 0, max: 0 } })} kg`,
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('co2Emission') as number) || 0), 0)

        return `${formatNumber(total, { digits: { min: 0, max: 0 } })} kg`
      },
    }),
    columnHelper.accessor('nOXEmission', {
      id: 'nOXEmission',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Sum NOX',
        alignmentType: 'right',
      },
      header: 'NOX',
      cell: (row) => `${formatNumber(row.getValue(), { digits: { min: 0, max: 0 } })} g` || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('nOXEmission') as number) || 0), 0)

        return formatEnvironmentNumber(total)
      },
    }),
  ]
}

function formatEnvironmentNumber(value: number): string {
  const settings = {
    digits: {
      min: 0,
      max: 0,
    },
  }
  const shouldShowInTonnes = value > 1000000000
  if (shouldShowInTonnes) return `${formatNumber(value / 1000000, settings)} t`

  const shouldShowInKg = value > 10000000
  if (shouldShowInKg) return `${formatNumber(value / 1000, settings)} kg`

  return `${formatNumber(value, settings)} g`
}
